export enum PlaceTypes {
  attractions = 'Достопримечательности',
  resorts = 'Курорты',
  hotels = 'Отели',
  restaurants = 'Кафе и рестораны',
  infrastructures = 'Инфраструктура',
}

export type PlaceTypesKeys = keyof typeof PlaceTypes;
